import { useContext } from 'react'
import { SustainabilityHeaderSlotContext } from './SustainabilityHeaderSlotContext'

export function useSustainabilityHeaderSlot() {
    return useContext(SustainabilityHeaderSlotContext)
}
